import React from 'react';
import { useState, useEffect } from 'react';
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button, Modal, Col, Spinner,
  FormGroup, Label, Input, ModalBody, ModalFooter, Alert
} from "reactstrap";
import { Form, Field } from "react-final-form";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import dataProvider from "dataProvider";
import { useHistory } from "react-router-dom";
import auth from "authProvider";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import ModalImage from "react-modal-image";
import decodeJwt from 'jwt-decode';
import moment from 'moment';
import DatePicker from "react-datepicker";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Scrollbars from 'react-custom-scrollbars';
import Pdf from "react-to-pdf";
import { AiOutlineDownload } from "react-icons/ai";
import jsPDF from 'jspdf'
import 'jspdf-autotable'


export const ExportToExcel = ({ apiData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button onClick={(e) => exportToCSV(apiData, fileName)} style={{ padding: 5, boxShadow: 0, borderWidth: 1, borderColor: '#ccc' }}><IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="share" /></Button>
  );
};

const ProductView = ({ item, actionToRoot, openparts, setOpenparts }) => {
  const [num, setNum] = useState(item.count);
  const [price, setPrice] = useState(item.price);
  const [desc, setDesc] = useState(item.desc);

  const onCountChange = (index, quantity) => {
    let count = parseInt(num) + parseInt(index);
    if (count < 0 || count > quantity) {
      return;
    }
    if (index === -1 && count === 1) {
      setOpenparts(true);
    }
    setNum(count);
    actionToRoot(item.productId, count, false);
  }
  const removeParts = () => {
    actionToRoot(item.productId, num, true);
  }
  return (
    <>
      <tr style={{ border: '1px solid #ccc' }}>
        <td style={{ color: '#044058', fontWeight: 'bold', textAlign: 'center', verticalAlign: 'middle' }}>{item.name}</td>
        <td>
          <div style={{ display: 'flex', flexDirection: 'row', width: '60%', backgroundColor: 'rgb(242 242 242)', marginBottom: 10, alignItems: 'center', marginTop: 10, borderRadius: '10px', alignItems: 'center' }}>
            <Button style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 0, padding: 5 }} onClick={() => onCountChange(-1, item.quantity)}><i style={{ opacity: num <= 1 ? 0.5 : 1, color: num <= 1 ? '#CCC' : '#000' }} class="ni ni-fat-delete"></i></Button>
            <span style={{ fontWeight: 'bold', fontSize: '0.7rem' }}>{num}</span>
            <Button style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 0, padding: 5, marginLeft: 10 }} onClick={() => onCountChange(1, item.quantity)} ><IcomoonReact iconSet={iconSet} color={num >= item.quantity ? '#CCC' : '#000'} style={{ opacity: num >= item.quantity ? 0.5 : 1 }} size={12} icon="add" /></Button>
          </div>
        </td>
        <td style={{ verticalAlign: 'middle', fontWeight: 600 }}>{num * price}</td>
        {/* {num * price === 0 ? <td style={{ verticalAlign: 'middle', fontWeight: 600 }}>{desc}</td> : <td>{null}</td>} */}
        <td>
          <Button onClick={() => removeParts()} style={{ backgroundColor: '#fff', boxShadow: 'none', fontSize: '0.625rem', border: 0, color: 'white', borderRadius: '20px' }}><IcomoonReact iconSet={iconSet} color="#ccc" size={20} icon="delete" /></Button>{' '}
        </td>
      </tr>
    </>
  )
}

const Reopened = (props) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [viewopen, setViewopen] = useState(false);
  const [statusopen, setStatusopen] = useState(false);
  const [openparts, setOpenparts] = useState(false);
  const [pos, setPos] = useState(false);
  const [position, setPosition] = useState(false);
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalerroropen, setModalErroropen] = useState(false);
  const [filter, setFilter] = useState(false);
  const [tenants, setTenants] = useState(false);
  const [technicians, setTechnicians] = useState(false);
  const [locations, setLocations] = useState(false);
  const [category, setCategory] = useState(false);
  const [priority, setPriority] = useState(false);
  const [days, setDays] = useState(false);
  const [places, setPlaces] = useState(false);
  const [services, setServices] = useState(false);
  const [productid, setProductid] = useState(false);

  const [catServices, setCatServices] = useState(false);
  const [locationslct, setLocationslct] = useState(false);
  const [sublocationslct, setSublocationslct] = useState(false);
  const [categoryslct, setCategoryslct] = useState(false);
  const [priorityslct, setPriorityslct] = useState(false);
  const [availableslct, setAvailableslct] = useState(false);
  const [timeslct, setTimeslct] = useState(false);
  const [placeslct, setPlaceslct] = useState(false);
  const [serviceslct, setServiceslct] = useState(false);
  const [technicianslct, setTechnicianslct] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [status_slct, setStatus_slct] = useState();
  const [opens, setOpens] = useState(false)
  const [openservice, setOpenservice] = useState(false)
  const [orders, setOrders] = useState(false)
  const [openorderedit, setOpenorderedit] = useState(false)
  const [num, setNum] = useState(1)
  const [tech, setTech] = useState([])
  const [image, setImage] = useState([])
  const [reason, setReason] = useState();
  const [error, setError] = useState(false);
  const [statuschange, Setstatuschange] = useState(false);
  const [techname, setTechname] = useState([]);
  const [searchtech, setSearchTech] = useState(false);
  const [searchsublocation, setSearchsubocation] = useState(false);
  const [searchpriority, setSearchPriority] = useState(false);
  const [searchstatus, setSearchStatus] = useState(false);
  const [reload, setReload] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });
  const [statusdlt_open, setstatusdlt_open] = useState({ visible: false, id: null, index: null });
  const [sucess, setSucess] = useState(false);
  const statusArr = ['completed', 'over due', 'in progress', 'reopened', 'assigned'];
  const [selectPartsInfo, setSelectPartsInfo] = useState([]);
  const [category_place, setCategory_place] = useState();
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [technicianlist, setTechnicianlist] = useState(false)
  const [peropen, setPeropen] = useState(false)
  const [dateslct, setDateslct] = useState(false);
  const [dateshow, setDateshow] = useState(false);
  const [exported, setExported] = useState([]);
  const [searchterm, setSearchTerm] = useState('');
  const [serviceresult, setServiceresult] = useState(false);
  const [dayslct, setDayslct] = useState(false);
  const [time, setTime] = useState(false);
  const [dayslabel, setDayslabel] = useState(false);
  const [dayarr, setDayarr] = useState(false);
  const [Todaytime, setTodaytime] = useState(false);
  const [Todaydate, setTodaydate] = useState(false);
  const [searchservices, setSearchServices] = useState(false);

  const ref = React.createRef();
  const doc = new jsPDF()

  const Pickdateslct = (date) => {
    let a = moment(date).format();
    setDateslct(a)
    setDateshow(date)
  }

  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  useEffect(() => {
    let token = localStorage.getItem('token');
    let filter = {};
    filter.status = 'reopened';
    dataProvider.getList('tenants', { params: { pagination: { page: 1, perPage: 500 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        if (data && data.length > 0) {
          let newLists = data.filter(item => {
            let today = new Date()
            let contract_date = new Date('' + item.contract_ended)
            if (contract_date > today || item.contract_ended === null) { return item }
          })
          let newList = newLists.filter(item => item.status !== 0)
          // var result = newList.map(tenant => ({ name: tenant.fullname, id: tenant.id, location: tenant.location, villa: tenant.villa, sublocation: tenant.sub_location }));
          // setTenants(result);
          // setLocationslct(tenants?.location)
          // setSublocationslct(tenants?.sub_location)
          var result = newList.map(tenant => ({ name: tenant?.fullname, id: tenant?.id, location: tenant?.location, villa: tenant?.villa, sublocation: tenant?.sub_location?._id, subloc: tenant?.sub_location?.location }));
          setTenants(result);
          setLocationslct(tenants?.location)
          setSublocationslct(tenants?.sublocaion)
        }
      })
    dataProvider.getList('locations/list', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setLocations(data[0].data); })
    dataProvider.getList('category', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setCategory(data); })
    dataProvider.getList('priority', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setPriority(data); })
    dataProvider.getList('days', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setDays(data); })
    dataProvider.getList('slots', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        let newList = data.filter(item => item.status !== 0)
        setTime(newList);
      })
    dataProvider.getList('places/list', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        setPlaces(data);
        setPlaces(data[0]?.data ? data[0].data : null);
      })
    dataProvider.getListservice('services', { params: { sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        if (data && data.length > 0) {
          var result = data.map(service => ({ id: service.id, name: service.title }));
          setServiceresult(result);
          // setSearchTerm('')
        }
        setServices(data);
      })
    dataProvider.getList('technicians', { params: { pagination: { page: 1, perPage: 500 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setTechnicians(data) })
    dataProvider.getList('products', { params: { pagination: { page: 1, perPage: 800 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        if (data && data.length > 0) {
          let newList = data.filter(item => item.quantity >= 1)
          var result = newList.map(product => ({ name: product.name, id: product.id, price: product.price, quantity: product.quantity }));
          setProducts(result);
        }
      })
    dataProvider.getList('orders', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        if (data && data.length > 0) {
          var obj = data.map(item => ({
            orderid: item?.orderId,
            Technician: getTechnicians(item.technicianIds),
            Created_Date: item?.created_on,
            Tenant: item?.tenantId?.fullname,
            service: item?.serviceId?.title,
            category: item?.categoryId?.category,
            priority: item?.priorityId?.priority,
            status: item?.status, Date: item?.date,
            Location: item?.locationId?.location,
            sublocation: item?.sub_locationId?.location,
            Time: item?.time
          }));
          setExported(obj);
        }
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setOrders(data);
        setSearchTerm('')
      })
      .catch(error => {
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });

  }, [props, reload]);

  function getTechnicians(ids) {
    var results = ids.map(a => a.fullname).join(',');
    return results;
  }

  const onFilterQuery = () => {
    let token = localStorage.getItem('token');
    let filter = {};

    if (searchtech) {
      filter.technicianIds = searchtech;
    }
    if (searchsublocation) {
      filter.sub_locationId = searchsublocation;
    }
    if (searchpriority) {
      filter.priorityId = searchpriority;
    }
    if (searchservices) {
      filter.serviceId = searchservices;
    }
    if (searchstatus) {
      filter.status = searchstatus;
    }
    filter.status = 'reopened';

    dataProvider.getList('orders', { params: { filter: filter, service: searchterm, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        if (data && data.length > 0) {
          var obj = data.map(item => ({ orderid: item?.orderId, Technician: item?.technicianIds[0]?.fullname ? item?.technicianIds[0]?.fullname : null, Created_Date: item?.created_on, Tenant: item?.tenantId?.fullname, service: item?.serviceId?.title, category: item?.categoryId?.category, priority: item?.priorityId?.priority, Location: item?.locationId?.location, sublocation: item?.sub_locationId?.location, status: item?.status, Time: item?.time }));
          setExported(obj);
        }
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setOrders(data);
        setSearchTerm('')
      })
      .catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  }

  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    onFilterQuery();
    setReload(!reload);
  }

  const onSubmit = values => {
    if (!tenants?.id || !serviceslct?.value || !placeslct?.value || !tenants?.location || !tenants?.sublocation) {
      setModalErroropen(true)
      return;
    }
    setLoading(false)
    dataProvider.createWorkorder('orders', { ...values, locationId: tenants?.location, sub_locationId: tenants?.sublocation, categoryId: categoryslct, priorityId: priorityslct, placeId: placeslct.value, serviceId: serviceslct.value, time: timeslct, availabilityId: dayslct, images: selectedFiles, tenantId: tenants.id, createdByAdmin: userid })
      .then(({ data }) => {
        setLoading(false)
        history.push("/workorder");
        setSucess(true)
        setTimeout(() => Push(), 1000);
        setOpen(false);
      })
      .catch(error => {
      });
  }
  const onSubmit_update = (values) => {
    dataProvider.update('orders', { id: orders[position].id, params: { ...values, status: status_slct, technicianIds: tech, productIds: selectPartsInfo, inventory: 1 } })
      .then(({ data }) => {
        setLoading(false)
        history.push("/reopened");
        setOpenorderedit(false);
      })
      .catch(error => {
        setLoading(false)
        alert(error.message)
      });

  }
  const onSubmit_status = () => {
  }
  const onSubmitSearch = (values) => {

  }
  const handleClickOpen = (index) => {
    setPos(index)
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    history.push('./reopened')
    setPlaceslct(false)
    setServiceslct(false)
  };
  const Openfilter = () => {
    setFilter(false)
    history.push('./reopened')
  }
  const Closefilter = () => {
    setFilter(true)
  }
  const opendropdown = () => {
    setOpens(!opens)
  }
  const placeSelection = (id, key, name, pid) => {
    setPlaceslct({ key: key, value: id, name })
  }
  const opendropdownservice = () => {
    setOpenservice(!openservice)
  }
  const opendropdowntechnician = () => {
    setOpenservice(!openservice)
  }
  const serviceSelection = (id, key) => {
    setServiceslct({ key: key, value: id })
  }
  const handleImageChange = (e) => {
    let img = selectedFiles;
    img.push(e.target.files[0]);
    setSelectedFiles(img);
    setImage(prevState => [...prevState, { info: e?.target?.files[0], path: URL.createObjectURL(e.target.files[0]) }]);
  };
  const removephoto = (item) => {
    let newFiles = selectedFiles.filter((pic) => pic.name !== item?.info?.name)
    setSelectedFiles(newFiles);
    let newImages = image.filter((pic) => pic.info.name !== item?.info?.name);
    setImage(newImages);

  }
  async function techniciansFilter(order) {
    return dataProvider.getTechnicians('technicians', { filter: { category: order?.categoryId?.id } }).then(({ data }) => {
      return data;
    }).catch(error => { return []; })
  }
  const Openorderedit = async (index, id) => {
    let newList = await techniciansFilter(orders[index]);
    // console.log(newList)
    setTechnicianlist(newList);
    setPosition(index)
    let techArr = orders[index]?.technicianIds.map(item => item._id);
    setTech(techArr);
    let techArray = orders[index]?.technicianIds.map(item => item.fullname);
    setTechname(techArray);
    setSelectPartsInfo(orders[index].productIds ? orders[index].productIds : [])
    setStatus_slct(orders[index].status ? orders[index].status : 'pending');
    setOpenorderedit(true);
    dataProvider.update('orders', { id: id, params: { show: 1 } }).then(({ data }) => { });
  }
  const orderClose = () => {
    setStatus_slct(false);
    setOpenorderedit(false);
  };
  const viewClose = () => {
    setViewopen(false);
  };
  const removeData = (id, index, status) => {
    dataProvider.delete('orders', { id: id });
    let userArr = orders;
    userArr.splice(index, 1);
    setOrders(userArr);
    setFlag(!flag)
    setConfirmOpen({ visible: false, id: null, index: null });

  }
  const technicianselect = async (val, key, checked) => {
    if (checked) {
      let newList = technicianslct.filter(item => item.id !== val)
      newList.push({ id: val, name: key })
      setTechnicianslct(newList);
      let newArr = tech.filter(item => item !== val)
      newArr.push(val)
      setTech(newArr)
    }

    else {
      let arrAfterRemove = technicianslct.filter(item => item.id !== val)
      setTechnicianslct(arrAfterRemove);
      let arrAfter = tech.filter(item => item !== val)
      setTech(arrAfter);
    }

  }
  const statuseditOpen = () => {
    setStatusopen(true);
  }
  const statuseditClose = () => {
    setStatus_slct(statuschange)
    setStatusopen(false);

  };
  const statusClose = () => {
    setStatusopen(false);

  };
  const selectparts = (val) => {
    var inPos = selectPartsInfo.find(part => part.productId === val.id);
    if (inPos) {
      alert('Product already in list.')
      return;
    }
    setSelectPartsInfo(prevState => [...prevState, { productId: val?.id, count: num, price: val?.price, name: val?.name, quantity: val?.quantity, desc: reason }]);
    return;
  }
  const partsclosemodal = (val) => {
    setOpenparts(false);
  }
  const categoryOnChange = (e) => {
    let catServices = services.filter(item => item?.category?.id === e);
    setCategoryslct(e);
    setCatServices(catServices);
    dataProvider.getCategory_Place({ id: e }).then(({ data }) => {
      setCategory_place(data.places);
    })
  }
  const resultsubmit = () => {
    setOpenparts(false);
  }
  const onSubmitFilter = values => {
  }
  const Filter_dropdown = () => {
    // setPage(1);
    onFilterQuery();
    // setReload(!reload);
  }
  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };
  const ClosemodalError = () => {
    setModalErroropen(false);
  };
  const statusdlt_close = () => {
    setstatusdlt_open({ visible: false, id: null, index: null });
  };
  const Push = () => {
    setSucess(false)
    // window.location.reload();
  }
  const SearchInfoQuantity = (val, id) => {
    let newArr = [...selectPartsInfo];
    let index = newArr.findIndex(i => i.productId === id);
    newArr[index].desc = val;
    setSelectPartsInfo(newArr);
  }

  const Dateshow = ({ date, priority, hours }) => {
    let toDate = new Date();
    let orderDate = new Date('' + date);
    var Difference_In_Time = toDate.getTime() - orderDate.getTime();
    var Difference_In_Days = parseInt(Difference_In_Time / (1000 * 3600 * 24));

    let orderDates = new Date('' + hours);
    var Difference_In_Times = toDate.getTime() - orderDates.getTime();
    const diffInhrs = parseInt(Difference_In_Times / (1000 * 60 * 60));

    var Difference_In_Times = toDate.getTime() - orderDates.getTime();
    const diffInMnts = parseInt(Difference_In_Times / (1000 * 60));

    var Difference_In_Times = toDate.getTime() - orderDates.getTime();
    const diffInScnds = parseInt(Difference_In_Times / (1000));
    // diffInhrs < 24 ? diffInhrs + 'Hours ago' : Difference_In_Days + 'days ago'

    // if (priority === 'Urgent') {
    //   return (
    //     <>
    //       <span>{diffInScnds < 60 ? diffInScnds + "seconds ago" : diffInMnts < 60 ? diffInMnts + " minute ago" : diffInhrs < 24 && diffInMnts >= 60 ? diffInhrs + " hours ago" : Difference_In_Days + 'days ago'} </span>
    //     </>
    //   )
    // }
    return (
      <span>{diffInhrs < 24 ? Difference_In_Days + " days" + ' ' + diffInhrs + 'hours ago' : Difference_In_Days + 'days ago'}</span>
      // <span>{Difference_In_Days} days ago</span>
    )
  }

  const actionFromRoot = (id, count, del) => {
    setProductid(id)
    if (del) {
      let partsFilter = selectPartsInfo.filter(item => item.productId !== id);
      setSelectPartsInfo(partsFilter)
    }
    else {
      let index = selectPartsInfo.findIndex(item => item.productId === id);
      if (index >= 0) {
        selectPartsInfo[index].count = count;
        setFlag(!flag)
      }
    }
  }
  const Viewopenorder = (index, id) => {
    var today = new Date();
    setTodaydate(today.toLocaleDateString("en-US"));
    setTodaytime(new Date().toLocaleTimeString());
    dataProvider.update('orders', { id: id, params: { show: 1 } })
      .then(({ data }) => {
      })
      .catch(error => {
        alert(error.message)
      });
    setViewopen(true)
    setPosition(index)
    let techArr = orders[index]?.technicianIds.map(item => item._id);
    setTech(techArr);
    let techArray = orders[index]?.technicianIds.map(item => item.fullname);
    setTechname(techArray);
    setSelectPartsInfo(orders[index].productIds ? orders[index].productIds : [])
    setStatus_slct(orders[index].status ? orders[index].status : 'pending')
  }
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();
  today = dd + '-' + mm + ' - ' + yyyy;
  let userid = localStorage.getItem('userid')
  let token = localStorage.getItem('token');
  let per = localStorage.getItem('permission');
  // const decodedToken = decodeJwt(token);
  // const per = decodedToken.user.permissions;

  const perModal = () => {
    setPeropen(true)
  }
  const permodalClose = () => {
    setPeropen(false)
  }
  const DisableCheckBox = () => {
    if (openservice) {
      setOpenservice(!openservice)
    }
  }
  let date = moment(orders[position]?.date).format('DD-MM-YYYY')
  let createddate = moment(orders[position]?.createdOn).format('DD-MM-YYYY,hh:mm:ss')

  const searchFilter = () => {
    setPage(1);
    onFilterQuery();
    // setReload(!reload);
  }
  // const Choosedservice = (val) => {
  //   setSearchTerm(val.id)
  //   let filter = {};
  //   if (val.id) {
  //     filter.serviceId = val.id;
  //   }
  //   filter.status = 'reopened';
  //   dataProvider.getList('orders', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
  //     .then(({ data }) => {
  //       if (data && data.length > 0) {
  //         var obj = data.map(item => ({ orderid: item?.orderId, Technician: item?.technicianIds[0]?.fullname ? item?.technicianIds[0]?.fullname : null, Created_Date: item?.created_on, Tenant: item?.tenantId?.fullname, service: item?.serviceId?.title, category: item?.categoryId?.category, priority: item?.priorityId?.priority, Location: item?.locationId?.location, sublocation: item?.sub_locationId?.location, status: item?.status, Time: item?.time }));
  //         setExported(obj);
  //       }
  //       if (data.length < 20) {
  //         setMore(false)
  //       }
  //       else {
  //         setMore(true)
  //       }
  //       setOrders(data);
  //       // setSearchTerm('')
  //     })
  //     .catch(error => {
  //       if (error?.response?.data?.message === 'Invalid Token') {
  //         setModalOpen(true)
  //       }
  //     });
  // }
  const Dayselect = (val) => {
    setDayslct(val)
    let arr = days.filter(x => x._id === val);
    arr.map((item, i) => {
      setDayslabel(item.title)
    })
    const weekdays = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
    const d = new Date();
    let day = weekdays[d.getDay()];
    setDayarr(day)
  }
  const handleKeyPress = (event) => {
    let token = localStorage.getItem('token');
    let filter = {};
    if (searchterm) {
      filter.orderId = searchterm.toLowerCase().replace(/\s/g, '');
    }
    filter.status = 'reopened';
    dataProvider.getList('orders', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        setOrders(data)
      }).catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  }



  if (!orders) {
    return (
      <>
        <div >
          <td style={{ color: '#12ACF6', position: "fixed", top: "50%", left: "55%", transform: "translate(-50%, -50%)" }} colSpan={11}><Spinner /></td>
        </div>
      </>
    )
  }


  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h1 className="mb-0" style={{ color: 'white', alignContent: 'flex-start' }}>REOPENED</h1>
              <div style={{ alignContent: 'flex-end', marginRight: '20px' }}>
                {per.includes('workorder_add') ? <Button onClick={() => handleClickOpen()} style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> NEW WORK ORDER</Button> :
                  <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> NEW WORK ORDER</Button>}
              </div>
            </Row>
          </div>
        </Container>
      </div>
      <Container className="mt--7"  >
        <Row>
          <div className="col" style={{ padding: 2 }}>
            <Card className="shadow" >
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                {filter ? <div style={{ alignContent: 'flex-start' }}><Button onClick={() => Openfilter()} style={{ backgroundColor: 'white', fontSize: '0.625rem', paddingLeft: '30px', paddingLeft: '20px', borderRadius: '10PX', borderColor: '#0C6C9A', color: '#0C6C9A' }}>
                  <IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10 }} color="#0C6C9A" size={12} icon="close" />FILTER</Button>{' '}
                </div> :
                  <div style={{ alignContent: 'flex-start' }}><Button onClick={() => Closefilter()} style={{ backgroundColor: 'white', fontSize: '0.625rem', paddingLeft: '30px', paddingLeft: '20px', borderRadius: '10PX', borderColor: '#0C6C9A', color: '#0C6C9A' }}>
                    <IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10 }} color="#0C6C9A" size={12} icon="filter" />FILTER</Button>{' '}
                  </div>
                }
                {/* <Col sm={8}>
                  <Form
                    onSubmit={onSubmitSearch}
                    render={({ handleSubmit, form }) => (
                      <form
                        onSubmit={async event => {
                          await handleSubmit(event)
                          form.reset()
                        }}>
                        <div>
                          <ReactSearchAutocomplete
                            styling={{
                              borderRadius: '8px',
                              boxShadow: 0,
                              clearIconMargin: '0 0 0 10px',
                              searchIconMargin: '0 8px 0 0',
                              padding: 0,
                              backgroundColor: '#eaf4f6',
                              placeholderColor: "#ccc",
                              height: "38px",
                              fontSize: "16px",
                              zIndex: 999,

                            }}
                            onSelect={Choosedservice}
                            // required
                            placeholder='Search Work orders'
                            items={serviceresult}
                            autoFocus
                          />
                        </div>
                      </form>
                    )}
                  />
                </Col > */}
                <Col sm={6} style={{ padding: 0 }}>
                  <Form
                    onSubmit={onSubmit}
                    render={({ handleSubmit, form }) => (
                      <form
                        onSubmit={async event => {
                          await handleSubmit(event)
                          form.reset()
                        }}>
                        <div className="pl-lg-4">
                          <Row>
                            <Col md="12">
                              <FormGroup>
                                <Field name="search">
                                  {({ input, meta, reset }) => (
                                    <div>
                                      <Input
                                        style={{ backgroundColor: '#E3F7F7' }}
                                        placeholder="Search Work Orders"
                                        value={searchterm}
                                        onKeyUp={(e) => handleKeyPress(e.target.value)}
                                        onChange={(event) => { setSearchTerm(event.target.value) }}
                                        type="text"
                                      />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                            <div style={{ position: 'absolute', right: 10 }}>
                              <Button onClick={() => searchFilter()} style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 0 }}><IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="search" /></Button>
                            </div>
                          </Row>
                        </div>
                      </form>
                    )}
                  />
                </Col >
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                  <ExportToExcel apiData={exported} fileName="Reopened" />
                </div>
              </CardHeader>
              {filter ?
                <Col>
                  <Form
                    onSubmit={onSubmitFilter}
                    render={({ handleSubmit }) => (
                      <form onSubmit={handleSubmit}>
                        <div className="pl-lg-4" >
                          <Row>
                            <Col lg="10">
                              <Row>
                                <Col lg="3">
                                  <FormGroup >
                                    <div style={{ display: 'flex' }}>
                                      <div style={{ flexDirection: 'row' }}>
                                        <IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="assigned-technician"> </IcomoonReact></div>
                                      <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }}>Assigned to</Label></div>
                                    </div>
                                    <Field name="technician" style={{ marginLeft: 10 }}  >
                                      {({ input, meta, value }) => (
                                        <div>
                                          <Input style={{ borderColor: 'rgb(231 235 238)', fontSize: '0.67rem', fontWeight: 600 }} type="select" onChange={(event) => setSearchTech(event.target.value)} name="person">
                                            <option style={{ fontSize: '0.8rem' }} value="">CHOOSE ASSIGNED PERSON</option>
                                            {technicians && technicians.map(item => (
                                              <option style={{ fontSize: '0.9rem', fontWeight: 600 }} value={item._id}>{item.fullname}</option>
                                            ))}
                                          </Input>
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                                {/* <Col lg="3" >
                                  <FormGroup >
                                    <div style={{ display: 'flex' }}>
                                      <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="loations"> </IcomoonReact></div>
                                      <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }} >Location</Label></div>
                                    </div>
                                    <Field name="location" >
                                      {({ input, meta, value }) => (
                                        <div>
                                          <Input style={{ borderColor: 'rgb(231 235 238)', fontSize: '0.65rem' }} type="select" onChange={(event) => { setSearchLocation(event.target.value) }} name="location" >
                                            <option value="">CHOOSE LOCATION</option>
                                            {locations && locations.map(item => (
                                              <option style={{ fontSize: '0.8rem', fontWeight: 600 }} value={item._id}>{item.location}</option>
                                            ))}
                                          </Input>
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col> */}
                                <Col lg="3" >
                                  <FormGroup >
                                    <div style={{ display: 'flex' }}>
                                      <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="loations"> </IcomoonReact></div>
                                      <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }} >Villa no.</Label></div>
                                    </div>
                                    <Field name="sub_locationId" >
                                      {({ input, meta, value }) => (
                                        <div>
                                          <Input style={{ borderColor: 'rgb(231 235 238)', fontSize: '0.75rem', fontWeight: 600 }} type="select" onChange={(event) => { setSearchsubocation(event.target.value) }} name="sub_locationId" >
                                            <option style={{ fontSize: '0.8rem' }} value="">CHOOSE VILLA</option>
                                            {locations && locations.length > 0 && (
                                              locations.map((item, index) => (
                                                <>
                                                  {item.children && item.children.length > 0 && (
                                                    item.children.map((child) => (
                                                      <option style={{ fontSize: '0.9rem', fontWeight: 600 }} value={child._id}>{child.location}</option>
                                                    ))
                                                  )}
                                                </>
                                              )))}
                                          </Input>
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                                <Col lg="3"  >
                                  <FormGroup >
                                    <div style={{ display: 'flex' }}>
                                      <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="priority"> </IcomoonReact></div>
                                      <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }} for="brand">Priority</Label></div>
                                    </div>
                                    <Field name="priority" >
                                      {({ input, meta, value }) => (
                                        <div>
                                          <Input style={{ borderColor: 'rgb(231 235 238)', fontSize: '0.75rem', fontWeight: 600 }} type="select" onChange={(event) => { setSearchPriority(event.target.value) }} name="priority">
                                            <option style={{ fontSize: '0.8rem' }} value="">CHOOSE PRIORITY LEVEL</option>
                                            {priority && priority.map(item => (
                                              <option style={{ fontSize: '0.9rem', fontWeight: 600 }} value={item._id}>{item.priority}</option>
                                            ))}
                                          </Input>
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                                <Col lg="3"  >
                                  <FormGroup >
                                    <div style={{ display: 'flex' }}>
                                      <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="services"> </IcomoonReact></div>
                                      <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }}>Services</Label></div>
                                    </div>
                                    <Field name="services" >
                                      {({ input, meta, value }) => (
                                        <div>
                                          <Input style={{ borderColor: 'rgb(231 235 238)', fontSize: '0.75rem', fontWeight: 600 }} type="select" onChange={(event) => { setSearchServices(event.target.value) }} name="priority">
                                            <option style={{ fontSize: '0.6rem' }} value="">CHOOSE SERVICE</option>
                                            {services && services.map(item => (
                                              <option style={{ fontSize: '0.8rem', fontWeight: 600 }} value={item?.id}>{item?.title}</option>
                                            ))}
                                          </Input>
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Col>
                            <div style={{ marginLeft: 10, marginTop: 30 }}>
                              <Button onClick={() => Filter_dropdown()} type="submit" style={{ backgroundColor: 'rgb(72 184 227)', color: 'white', width: 120, border: 0 }}>Apply</Button>
                            </div>
                          </Row>
                        </div>
                      </form>
                    )}
                  />
                </Col > : null}
              <div style={{ width: '100%', overflow: 'hidden', overflowX: 'auto' }}>
                <Table className="align-items-center table-flush"  >
                  <thead className="thead-light" >
                    <tr>
                      <th style={{ color: '#708a9f', fontSize: '0.65rem' }} scope="col">ID</th>
                      <th style={{ color: '#708a9f', fontSize: '0.65rem' }} scope="col">SERVICE NAME</th>
                      <th style={{ color: '#708a9f', fontSize: '0.65rem' }} scope="col">CATEGORY</th>
                      <th style={{ color: '#708a9f', fontSize: '0.65rem', textAlign: 'center' }} scope="col">PRIORITY</th>
                      <th style={{ color: '#708a9f', fontSize: '0.65rem' }} scope="col">ASSIGNED TO</th>
                      <th style={{ color: '#708a9f', fontSize: '0.65rem' }} scope="col">STATUS</th>
                      <th style={{ color: '#708a9f', fontSize: '0.65rem' }} scope="col">LOCATION</th>
                      <th style={{ color: '#708a9f', fontSize: '0.65rem' }} scope="col">CREATED BY</th>
                      <th style={{ color: '#708a9f', fontSize: '0.65rem' }} scope="col">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!orders || orders.length < 1 ? (
                      <tr>
                        <td style={{ color: '#12ACF6', textAlign: 'center', padding: 20, margin: 20 }} colSpan={11}>No Results found
                          <IcomoonReact style={{ marginLeft: 10 }} iconSet={iconSet} color="#12ACF6" size={22} icon="search" />
                        </td>
                      </tr>
                    ) : (
                      <>
                        {orders.map((order, index) => (
                          <tr>
                            <td style={{ color: '#ccc', fontSize: '0.7rem', paddingRight: 0 }}>#{order?.orderId}
                              <div>
                                {order.reOpenedOn && (<Dateshow date={order?.reOpenedOn} hours={order.reOpenedOn} priority={order?.priorityId?.priority} />)}
                              </div>
                            </td>
                            <td style={{ width: 10, fontWeight: 600, padding: '10px 10px 0px 10px' }}>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label style={{ fontSize: '0.5rem', textTransform: 'uppercase', color: 'red' }}>{order?.status === 'reopened' ? order?.status : null} </label>
                                {order?.status === 'reopened' ?
                                  <span style={{ display: 'flex' }} class="badge-dot badge ">
                                    <i class="bg-danger"></i>
                                    <label style={{ fontSize: '0.75rem', color: 'red' }}>{order?.serviceId?.title}</label>
                                  </span>
                                  :
                                  <label style={{ color: '#28c0f1', fontSize: '0.75rem' }}>{order?.serviceId?.title}</label>
                                }
                              </div>
                            </td>
                            <td style={{ fontSize: '0.75rem', width: 10, padding: '10px 10px 0px 10px', color: '#767570', fontWeight: 'bold' }}>{order?.categoryId?.category}</td>
                            <td><Button style={{ backgroundColor: '#f9cfcf', border: 'none', boxShadow: 'none', padding: '7px 13px 7px 13px', cursor: 'default', marginLeft: 8 }}><label style={{ margin: 0, color: '#fc6820', fontSize: '0.6rem', display: 'flex', textTransform: 'uppercase', textAlign: 'center', fontWeight: 'bold' }}>{order?.priorityId?.priority}</label></Button></td>

                            {order?.technicianIds && order?.technicianIds.length > 0 ?
                              <td >
                                {order?.technicianIds.map((item, index) => {
                                  return (
                                    <div style={{ fontSize: '0.7rem', display: 'block', padding: '10px 10px 0px 10px' }}>{item.fullname}  </div>
                                  )
                                })}
                              </td> : <td style={{ fontSize: '0.7rem', padding: '10px 10px 0px 10px' }}>Not Assigned</td>
                            }
                            {order?.status === 'reopened' ? <td style={{ padding: 5 }}><Button style={{ backgroundColor: '#f9cfcf', border: 'none', boxShadow: 'none', textAlign: 'center', textTransform: 'uppercase', color: '#fc6820', padding: '7px 13px 7px 13px', fontSize: '0.6rem', fontWeight: 'bold' }}>{order?.status ? order.status : null}</Button></td> : null}
                            <td style={{ fontSize: '0.6rem', paddingRight: 0, display: 'flex', flexDirection: 'column' }}>
                              <label style={{ whiteSpace: 'nowrap', padding: 0 }} >{order.sub_locationId.location ? order.sub_locationId.location : null}</label>
                              <label>{order?.locationId?.location}</label>
                            </td>
                            <td style={{ fontSize: '0.7rem', paddingRight: 0, textTransform: 'capitalize', width: 10 }}>{order?.createdBy ? order?.createdBy : order?.createdByAdmin?.role}</td>
                            {/* <td style={{ flexDirection: 'row', paddingLeft: 0, paddingRight: 0 }}>
                              <Button onClick={() => Viewopenorder(index, order.id)} style={{ boxShadow: 'none', backgroundColor: 'rgb(45 206 137)', borderColor: '#fff', padding: 4, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="white" size={20} icon="view" /></Button>
                              <Button onClick={() => Openorderedit(index, order.id)} style={{ boxShadow: 'none', backgroundColor: 'rgb(49 162 238)', borderColor: 'rgb(49 162 238)', padding: 4, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="white" size={15} icon="edit" /></Button>
                              <Button style={{ boxShadow: 'none', backgroundColor: 'rgb(242 95 95)', borderColor: '#fff', padding: 4, textAlign: 'center' }} onClick={() => setstatusdlt_open({ visible: true, id: order.id, index: index, status: order.status })} ><IcomoonReact iconSet={iconSet} color="white" size={20} icon="delete" /> </Button>
                            </td> */}
                            <td style={{ flexDirection: 'row', paddingLeft: 0, paddingRight: 0 }}>
                              <Button onClick={() => Viewopenorder(index, order.id)} style={{ boxShadow: 'none', backgroundColor: 'rgb(45 206 137)', borderColor: '#fff', padding: 4, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="white" size={20} icon="view" /></Button>
                              {per.includes('workorder_edit') ? <Button onClick={() => Openorderedit(index, order.id)} style={{ boxShadow: 'none', backgroundColor: 'rgb(49 162 238)', borderColor: 'rgb(49 162 238)', padding: 5, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="white" size={18} icon="edit" /></Button> :
                                <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: 'rgb(49 162 238)', borderColor: 'rgb(49 162 238)', padding: 4, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="white" size={14} icon="edit" /></Button>}
                              {statusArr.includes(order.status) ?
                                <Button style={{ boxShadow: 'none', backgroundColor: 'rgb(242 95 95)', borderColor: '#fff', padding: 4, textAlign: 'center' }} onClick={() => setstatusdlt_open({ visible: true, id: order.id, index: index, status: order.status })} ><IcomoonReact iconSet={iconSet} color="white" size={18} icon="delete" /> </Button> :
                                per.includes('workorder_delete') ? <Button style={{ boxShadow: 'none', backgroundColor: 'rgb(242 95 95)', borderColor: '#fff', padding: 4, textAlign: 'center' }} onClick={() => setConfirmOpen({ visible: true, id: order.id, index: index })} ><IcomoonReact iconSet={iconSet} color="white" size={18} icon="delete" /> </Button> :
                                  <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: 'rgb(242 95 95)', borderColor: '#fff', padding: 4, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="white" size={18} icon="delete" /></Button>}
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </Table>
              </div>
              {/* delete confirmation */}
              <Modal isOpen={confirmOpen.visible} size="sm">
                <div className="modal-header"></div>
                <ModalBody style={{ color: 'red', padding: 0, paddingLeft: 20 }}>DO YOU WANT DELETE THIS  ?</ModalBody>
                <ModalFooter >
                  <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    NO
                  </Button>
                  <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index, confirmOpen.status)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    YES
                  </Button>
                </ModalFooter>
              </Modal>
              {/* --------*/}
              {/* cannot delete confirmation */}
              <Modal isOpen={statusdlt_open.visible} size="sm">
                <ModalBody style={{ color: 'red', padding: 20, paddingLeft: 20, paddingTop: 10, marginTop: 20 }}> This orders cannot be deleted...!</ModalBody>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
                  <Button onClick={statusdlt_close} style={{ backgroundColor: 'rgb(242 95 95)', color: 'white' }} type="button">
                    OK
                  </Button>
                </div>
              </Modal>
              {/* --- */}
              {/* created sucess */}
              <Modal isOpen={sucess} size="sm">
                <ModalBody style={{ color: 'green' }}>Created successfully!</ModalBody>
              </Modal>
              {/* ---- */}
            </Card>
          </div>
        </Row>
      </Container>
      {/* add new workorder */}
      <div style={{ width: '600px' }}>
        <Modal
          className="modal-dialog-centered"
          isOpen={open}
          style={{ maxWidth: '750px' }}
        >
          <div onClick={handleClose} style={{ backgroundColor: 'rgb(193 193 124)', cursor: 'pointer', width: '30px', height: '30px', position: 'absolute', right: '-6px', top: '-10px', borderRadius: '50%' }}>
            <IcomoonReact iconSet={iconSet} onClick={handleClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div className="modal-header" style={{ backgroundColor: 'rgb(5 160 187)', padding: 5, flexDirection: 'column' }} >
            <h2 style={{ marginTop: '20px', marginLeft: 20, color: 'white' }} className="modal-title" id="exampleModalLabel">
              ADD NEW WORK ORDERS
            </h2>
            <h2 style={{ marginTop: '20px', marginLeft: 20, color: 'white', fontSize: '0.8rem', marginTop: 5 }}>
              <label>Created on {today}</label>
            </h2>
          </div>
          <Scrollbars
            renderThumbVertical={props => < div {...props} className="thumb-vertical" />}
            renderTrackVertical={props => < div {...props} className="track-vertical" />}
            renderThumbHorizontal={props => < div {...props} />}
            style={{ height: 430 }}>
            <div>
              <Form
                onSubmit={onSubmit}
                validate={values => {
                  const errors = {};
                  return errors;
                }}
                render={({ handleSubmit }) => (
                  <form
                    onSubmit={handleSubmit} style={{ padding: '5px 20px 10px 0px' }}>
                    <div className="pl-lg-4">
                      <Row>
                        <Col md="4">
                          <Label style={{ fontSize: ' 0.75rem', color: '#6c6f8a' }}>TENANT </Label>
                          <Field>
                            {({ input, meta, value }) => (
                              <div>
                                <ReactSearchAutocomplete
                                  styling={{
                                    borderRadius: '8px',
                                    clearIconMargin: '0 0 0 10px',
                                    searchIconMargin: '0 10px 0 0',
                                    placeholderColor: "#048ecb",
                                    zIndex: 1,
                                    // fontSize:'12px',
                                    // fontWeight:'bolder',
                                  }}
                                  onSelect={setTenants}
                                  fuseOptions={{ keys: ["name", "subloc"] }}
                                  resultStringKeyName="name"
                                  placeholder='Tenant id'
                                  items={tenants}
                                  autoFocus
                                />
                              </div>
                            )}
                          </Field>
                          <span style={{ color: 'red', fontSize: '0.8rem', paddingLeft: 22 }}>{error}</span>
                        </Col>
                        <Col lg="4">
                          <FormGroup >
                            <Label style={{ fontSize: ' 0.75rem', color: '#6c6f8a' }} >LOCATION</Label>
                            <Field name="location"  >
                              {({ input, meta, value }) => (
                                <div>
                                  <div><IcomoonReact iconSet={iconSet} style={{ position: 'absolute', top: 35, margin: 10, marginLeft: 10 }} color="rgb(15 145 187)" size={14} icon="loations" /></div>
                                  <Input required value={tenants?.location} disabled autoComplete={true} type="select" name="location" id="location" style={{ color: 'black', paddingLeft: 25, paddingLeft: '30px', backgroundColor: 'white', borderRadius: 8, height: 45 }}>
                                    <option value=""></option>
                                    {locations && locations.map(item => (
                                      <option value={item._id}>{item.location} </option>
                                    ))}
                                  </Input>
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup >
                            <Label style={{ fontSize: ' 0.75rem', color: '#6c6f8a' }} for="sublocation">VILLA NO</Label>
                            <Field name="sublocation" >
                              {({ input, meta, value }) => (
                                <div>
                                  <div><IcomoonReact iconSet={iconSet} style={{ position: 'absolute', top: 35, margin: 10, marginLeft: 10 }} color="rgb(15 145 187)" size={14} icon="loations" /></div>
                                  <Input required value={tenants?.sublocation} type="select" name="sublocation" disabled style={{ color: 'black', paddingLeft: 25, backgroundColor: 'white', borderRadius: 8, height: 45 }}>
                                    <option value=""></option>
                                    {locations && locations.length > 0 && (
                                      locations.map((item, index) => (
                                        <>
                                          {item.children && item.children.length > 0 && (
                                            item.children.map((child) => (
                                              <option value={child._id}>{child.location}</option>
                                            ))
                                          )}
                                        </>
                                      )))}
                                  </Input>
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup >
                            <Label style={{ fontSize: ' 0.75rem', color: '#6c6f8a' }} for="category"> SELECT CATEGORY</Label>
                            <Field name="category" >
                              {({ input, meta, value }) => (
                                <div>
                                  <Input required type="select" name="category" id="category" onChange={(e) => categoryOnChange(e.target.value)} style={{
                                    fontSize: '0.85rem', color: '#5d5d4d',
                                    fontWeight: '600', borderRadius: 8, height: 45
                                  }}>
                                    <option value="">--Select--</option>
                                    {category && category.map(item => (
                                      <option value={item._id}>{item.category}</option>
                                    ))}
                                  </Input>
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup >
                            <Label style={{ fontSize: ' 0.75rem', color: '#6c6f8a' }} for="priority">CHOOSE PRIORITY</Label>
                            <Field name="priority" >
                              {({ input, meta, value }) => (
                                <div>
                                  <Input required type="select" name="priority" id="priority" onChange={(e) => setPriorityslct(e.target.value)} style={{ fontSize: '0.85rem', color: '#5d5d4d', fontWeight: '600', borderRadius: 8, height: 45 }}>
                                    <option value="">--Select--</option>
                                    {priority && priority.map(item => (
                                      <option value={item._id}>{item.priority}</option>
                                    ))}
                                  </Input>
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        {/* <Col lg="6">
                        <div style={{ position: 'absolute', right: 30, top: 40, zIndex: 999 }}><IcomoonReact iconSet={iconSet} color="#77665c" size={16} icon="date-picker" /> </div>
                        <FormGroup >
                          <Label style={{ fontSize: ' 0.75rem' }}>CHOOSE DATE</Label>
                          <Field name="date"  >
                            {({ input, meta, value }) => (
                              <DatePicker
                                style={{ zIndex: 999 }}
                                selected={dateshow}
                                onChange={(date) => Pickdateslct(date)}
                                dateFormat='dd/MM/yyyy'
                                placeholderText="DD/MM/YYYY"
                                required={true}
                                minDate={new Date()}
                                isClearable={false}
                                className="datePicker"
                              />
                            )}
                          </Field>
                        </FormGroup>
                      </Col> */}
                        <Col lg="6">
                          <FormGroup >
                            <Label style={{ fontSize: ' 0.75rem', color: '#6c6f8a' }} for="supplier">CHOOSE DAY</Label>
                            <Field name="availabilityId" >
                              {({ input, meta, value }) => (
                                <div>
                                  <Input required type="select" onChange={(e) => Dayselect(e.target.value)} style={{ fontSize: '0.85rem', color: '#5d5d4d', fontWeight: '600', borderRadius: 8, height: 45 }}>
                                    <option value="">--Select--</option>
                                    {days && days.map(item => (
                                      <option value={item._id}>{item.title}</option>
                                    ))}
                                  </Input>
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        {dayarr === dayslabel ? <Col lg="6">
                          <FormGroup >
                            <Label style={{ fontSize: ' 0.75rem', color: '#6c6f8a' }} for="supplier">CHOOSE TIME</Label>
                            <Field name="time" >
                              {({ input, meta, value }) => (
                                <div>
                                  <Input required type="select" name="time" id="time" onChange={(e) => setTimeslct(e.target.value)} style={{ fontSize: '0.85rem', color: '#5d5d4d', fontWeight: '600', borderRadius: 8, height: 45 }}>
                                    <option value="">--Select--</option>
                                    {time && time.map(item => {
                                      var t = new Date(); // for now
                                      const t1 = t.getHours();
                                      var input = item.slot;
                                      let times;
                                      var fields = input.split('-');
                                      let timeStart = fields[0].replace(/ /g, '');

                                      if (timeStart.includes('AM')) {
                                        times = parseFloat(timeStart.replace('AM', ''));
                                      } else if (timeStart.includes('PM')) {
                                        times = parseFloat(timeStart.replace('PM', '')) + 12;
                                      }
                                      if (t1 < times) {
                                        return (
                                          <option value={item.slot}>{item.slot}</option>
                                        );
                                      }
                                      else {
                                        return null;
                                      }
                                    })}
                                  </Input>
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                          :
                          <Col lg="6">
                            <FormGroup >
                              <Label style={{ fontSize: ' 0.75rem', color: '#6c6f8a' }} for="supplier">CHOOSE TIME</Label>
                              <Field name="time" >
                                {({ input, meta, value }) => (
                                  <div>
                                    <Input required type="select" name="time" id="time" onChange={(e) => setTimeslct(e.target.value)} style={{ fontSize: '0.85rem', color: '#5d5d4d', fontWeight: '600', borderRadius: 8, height: 45 }}>
                                      <option value="">--Select--</option>
                                      {time && time.map(item => (
                                        <option value={item.slot}>{item.slot}</option>
                                      ))}
                                    </Input>
                                  </div>
                                )}
                              </Field>
                            </FormGroup>
                          </Col>
                        }
                      </Row>
                      <Row>
                        <Col lg="6">
                          <label style={{ fontSize: '0.8rem', color: '#6c6f8a' }}>CHOOSE PLACE</label>
                          <div onClick={() => opendropdown()} style={{ width: 'maxContent' }}>
                            <div style={{ border: '1px solid rgb(187, 187, 187)', height: '46px', borderRadius: '8px' }} >
                              <input required type="select" disabled name="" onClick={() => opendropdown()} value={placeslct ? placeslct.key + " - " + placeslct.name : 'select a place'} id="" style={{
                                width: '100% ',
                                backgroundColor: 'transparent',
                                padding: '0.7rem',
                                color: 'rgb(93 93 73)',
                                outline: 'none',
                                border: 'none',
                                textTransform: 'uppercase',
                                fontSize: '0.85rem',
                                color: '#5d5d4d',
                                fontWeight: '600',
                                borderRadius: 10,
                              }} />
                              <div style={{ float: 'right' }}>
                                <IcomoonReact iconSet={iconSet} style={{ margin: 20, position: 'absolute', right: 10 }} color="rgb(93 93 77)" size={12} icon="drop-down" />
                              </div>
                            </div>
                            {opens &&
                              (<div style={{
                                width: '18rem', backgroundColor: 'white', padding: '0.3rem', boxShadow: '0 30px 60px rgb(0,0,0,0.2)', position: 'absolute',
                                zIndex: '9',
                                height: '200px',
                                overflow: 'hidden',
                                overflowY: 'scroll',
                              }}>
                                {category_place && category_place.length > 0 && (
                                  category_place.map((item, index) => (
                                    <>
                                      <ul>
                                        <li style={{ listStyleType: 'none', color: '#064050', marginLeft: 5 }}>
                                          <label style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.8rem' }}>{item.title ? item.title : null}</label>
                                          {item.children && item.children.length > 0 && (
                                            item.children.map((child) => (
                                              <>
                                                <label for="task1" style={{ display: 'block', marginLeft: 20, color: '#024d8d', fontWeight: 'bold' }}>
                                                  <input required value={child.id} onChange={(e) => placeSelection(e.target.value, item.title ? item.title : null, item.children ? child.title : null, item.id)} type="radio" name="radio" />
                                                  <label style={{ textTransform: 'uppercase', fontSize: '0.8rem', marginLeft: 5 }}>{child.title}</label>
                                                </label>
                                              </>
                                            ))
                                          )}
                                        </li>
                                      </ul>
                                    </>
                                  )))}
                              </div>)}
                          </div>
                        </Col>
                        <Col lg="6">
                          <label style={{ fontSize: '0.8rem', color: '#6c6f8a' }}>CHOOSE SERVICE</label>
                          <div style={{ width: 'maxContent', marginBottom: 10 }}>
                            <div onClick={() => opendropdownservice()} style={{ border: '1px solid rgb(187, 187, 187)', height: '46px', borderRadius: '8px', margin: 0 }} >
                              <input type="text" disabled name="" value={serviceslct ? serviceslct.key : 'Select a service'} id=""
                                style={{
                                  width: '100%',
                                  backgroundColor: 'transparent',
                                  color: 'black',
                                  padding: '0.8rem',
                                  color: 'rgb(93 93 73)',
                                  outline: 'none',
                                  border: 'none',
                                  textTransform: 'uppercase',
                                  fontSize: '0.85rem',
                                  color: '#5d5d4d',
                                  fontWeight: '600',

                                }} />
                              <div style={{ position: 'absolute', right: 30, top: 40 }}>
                                <IcomoonReact iconSet={iconSet} color="rgb(93 93 77)" size={12} icon="drop-down" />
                              </div>
                            </div>
                            {openservice ?
                              <div style={{
                                width: '18rem', backgroundColor: 'white', padding: '0.8rem', boxShadow: '0 30px 60px rgb(0,0,0,0.2)', position: 'absolute', zIndex: '9',
                              }}>
                                {catServices && catServices.length > 0 && (
                                  catServices.map((item, index) => (
                                    <ul>
                                      <li style={{ listStyleType: 'none', display: 'flex' }}>
                                        <input required onClick={() => opendropdownservice()} style={{ float: 'left' }} value={item._id} onChange={(e) => serviceSelection(e.target.value, item?.title)} type="radio" name="radio" />
                                        <label style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.8rem', marginLeft: 10 }}>{item.title}</label>
                                      </li>
                                    </ul>
                                  )))}
                              </div> : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12" style={{ marginTop: 30 }}>
                          <FormGroup>
                            <Label style={{ fontSize: ' 0.75rem', color: '#6c6f8a' }} >DESCRIBE YOUR PROBLEM IN YOUR WORDS</Label>
                            <Field name="description" >
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    {...input}
                                    type="textarea"
                                    style={{ color: 'black', padding: 25, overflow: 'hidden', borderRadius: 10 }}
                                    placeholder="Description"
                                  // invalid={meta.error && meta.touched}
                                  />
                                  {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4">
                          <FormGroup >
                            <>
                              <div>
                                <div style={{ border: '2px dotted #ccc', paddingRight: '5px', width: 132, borderRadius: 10 }}>
                                  <input accept=".jpg,.jpeg,.png" type="file" id="file" multiple onChange={handleImageChange} />
                                  <IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', margin: 10 }} color="rgb(93 93 73)" size={20} icon="add-photos" />
                                  <label htmlFor="file" style={{ color: '#ccc', padding: '0.3rem', fontSize: '0.6rem', cursor: 'pointer', marginTop: '0.5rem' }}>
                                    ADD PHOTOS
                                  </label>
                                </div>
                                {image && image.length > 0 && (
                                  image.map((item, index) => (
                                    <div style={{ width: '5rem', margin: 10 }}>
                                      <Button onClick={() => removephoto(item)} style={{ boxShadow: 'none', backgroundColor: 'transparent', border: 0 }}><IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10 }} color="#0C6C9A" size={12} icon="close" />{' '}</Button>
                                      <img
                                        src={item?.path}
                                        className="img-fluid"
                                        alt="..."
                                      />
                                    </div>
                                  )))}
                              </div>
                            </>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <Col md="6" >
                        <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: 'rgb(0 139 183)', width: '80%', color: 'white', borderRadius: '50px', boxShadow: 'none', padding: 15, marginBottom: 20, fontSize: '1rem' }} >
                          {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                          SUBMIT</Button>{' '}
                      </Col>
                    </div>
                  </form>
                )}
              />
            </div>
          </Scrollbars>
        </Modal>
      </div>
      {/* ----*/}
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      {/* edit workorder */}
      <div style={{ width: '600px' }}>
        <Modal
          className="modal-dialog-centered"
          isOpen={openorderedit}
          onClick={() => DisableCheckBox()}
          style={{ maxWidth: '750px' }} >

          <div onClick={orderClose} style={{ backgroundColor: 'rgb(193 193 124)', width: '30px', height: '30px', position: 'absolute', right: '-6px', top: '-10px', borderRadius: '50%', cursor: 'pointer' }}>
            <IcomoonReact iconSet={iconSet} onClick={orderClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div className="modal-header" style={{ backgroundColor: 'rgb(5 160 187)', flexDirection: 'column', display: 'flex', padding: '8px' }} >
            <h2 style={{ marginTop: '20px', marginLeft: 30, color: 'white', textTransform: 'uppercase' }} className="modal-title" id="exampleModalLabel">
              {orders[position]?.serviceId?.title}
            </h2>
            <h3 style={{ marginTop: '20px', marginLeft: 30, color: 'white', fontSize: '0.8rem', marginTop: 5 }}>
              <label style={{ color: 'rgb(128 207 209)' }}>Created on {moment(orders[position]?.createdOn).format('LLL')}</label>
            </h3>
          </div>
          <div>
            <Form
              onSubmit={onSubmit_update}
              render={({ handleSubmit }) => (
                <form
                  onSubmit={handleSubmit} style={{ padding: '10px' }}>
                  <Scrollbars
                    renderThumbVertical={props => < div {...props} className="thumb-vertical" />}
                    renderTrackVertical={props => < div {...props} className="track-vertical" />}
                    renderThumbHorizontal={props => < div {...props} />}
                    // onScrollStart={props => < div {...props} className="scroll-start" />}
                    // renderView={props => <div {...props} className="view" />}
                    //scrollToBottom
                    autoHide={false}
                    autoHeight={true}
                    autoHeightMin={432}
                    autoHeightMax={432}
                  >
                    <div className="pl-lg-4">
                      <Row style={{ borderBottom: '1px solid #eeeeee', width: '100%' }}>
                        <Col lg="5" style={{ width: '40%' }}>
                          <div style={{ width: 'maxContent', marginBottom: 20 }}>
                            <div style={{
                              border: '1px solid rgb(0 139 183)',
                              height: '60px',
                              borderRadius: '5px',
                              margin: 0,
                              overflow: 'hidden',
                              fontWeight: 600
                            }} >
                              <div onClick={() => opendropdowntechnician()} style={{ display: 'flex', marginLeft: 10, marginTop: 5 }}>
                                <div style={{ border: '1px solid rgb(0 139 183)', width: 30, borderRadius: '50%', height: 30, marginTop: 8 }}>
                                  <IcomoonReact style={{ marginLeft: 5 }} iconSet={iconSet} color="rgb(14 145 186)" size={20} icon="assigned-technician" />
                                </div>
                                {technicianslct && technicianslct.length > 0 || orders[position]?.technicianIds && orders[position]?.technicianIds.length > 0 ?
                                  <div><label style={{ fontSize: '0.6rem', marginLeft: 10 }}>ASSIGNED</label></div> :
                                  <div><label style={{ fontSize: '0.6rem', marginLeft: 10 }}>NOT ASSIGNED</label></div>}
                              </div>
                              <div onClick={() => opendropdowntechnician()} style={{ display: 'flex', marginLeft: 40, marginTop: '-10px' }}>
                                {technicianslct && technicianslct.length > 0 ? (
                                  technicianslct.map((item, index) => (
                                    <div type="text" id=""
                                      style={{
                                        width: '200px',
                                        backgroundColor: 'transparent',
                                        color: 'rgb(0 139 183)',
                                        padding: '0px',
                                        marginLeft: 10,
                                        display: 'inline-block',
                                        outline: 'none',
                                        border: 'none',
                                        fontSize: '0.8rem',
                                        whiteSpace: 'nowrap',
                                      }}>{item?.name}</div>
                                  ))
                                ) : (
                                  <div style={{
                                    width: '100%',
                                    backgroundColor: 'transparent',
                                    color: 'rgb(0 139 183)',
                                    padding: '0px',
                                    outline: 'none',
                                    border: 'none',
                                    fontSize: '0.8rem',
                                    paddingLeft: 6
                                  }}>{techname && techname.length > 0 ? techname : 'ASSIGN A TECHNICIAN'}</div>
                                )}
                              </div>
                              <div onClick={() => opendropdowntechnician()} style={{ position: 'absolute', right: 30, top: 15, }}>
                                <IcomoonReact iconSet={iconSet} color="rgb(14 145 186)" size={12} icon="drop-down" />
                              </div>
                            </div>
                            {openservice ?
                              <div style={{
                                width: '16rem', backgroundColor: 'white', padding: '0.8rem', boxShadow: '0 30px 60px rgb(0,0,0,0.2)', position: 'absolute', zIndex: '9',
                                overflow: 'hidden',
                              }}>
                                {technicianlist && technicianlist.length > 0 && (
                                  <>
                                    <ul>
                                      {technicianlist.map((item, index) => (
                                        <>
                                          <li style={{ listStyleType: 'none', display: 'flex' }}>
                                            <input checked={tech.includes(item._id) || orders[position]?.technicianIds.includes(item._id)} style={{ float: 'left' }} value={item._id} onChange={(e) => technicianselect(e.target.value, item?.fullname, e.target.checked)} type="checkbox" name="check" />
                                            <label style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.8rem', marginLeft: 10 }}>{item.fullname}</label>
                                          </li>
                                        </>
                                      ))}
                                    </ul>
                                  </>
                                )}
                              </div> : null}
                          </div>
                        </Col>
                        <Col md="3" onClick={() => statuseditOpen()} style={{ display: 'flex', flexDirection: 'column' }}>
                          <label style={{ fontSize: '0.6rem', textTransform: 'uppercase', marginLeft: 20 }}>status</label>
                          <div style={{ display: 'flex', marginLeft: 20 }}>
                            <div>
                              <span class="badge-dot badge ">
                                <i class={(status_slct === 'completed' || orders[position]?.status === 'completed') ? 'bg-success' : 'bg-danger'}></i>
                              </span>
                            </div>
                            <div>
                              <label style={{
                                color: (status_slct === 'completed' || orders[position]?.status === 'completed') ? 'green' : 'red',
                                border: '1px solid transparent',
                                backgroundColor: '#fff',
                                paddingBottom: 25,
                                textTransform: 'uppercase',
                                fontWeight: 900,
                                fontSize: '0.8rem'
                              }}>
                                {status_slct || orders[position]?.status || 'pending'}
                              </label>
                            </div>
                          </div>
                        </Col>
                        {orders[position]?.availabilityId !== null && orders[position]?.priorityId.priority === 'Normal' ?
                          <Col md="4" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>Date & Time </label>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <label style={{ fontSize: '0.9rem', color: 'rgb(13 151 207)', textTransform: 'capitalize', fontWeight: 'bold' }}>{orders[position]?.availabilityId?.title ? orders[position]?.availabilityId?.title : null}</label>
                              <label style={{ fontSize: '0.9rem', color: 'rgb(13 151 207)', textTransform: 'capitalize', fontWeight: 'bold' }}>{orders[position]?.time ? orders[position]?.time : null}</label>
                            </div>
                          </Col> : null}
                      </Row>
                      <Row style={{ borderBottom: '1px solid #eeeeee', width: '100%' }}>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>order id</label>
                          <div>
                            <label style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.85rem', color: 'rgb(13 151 207)' }}>{orders[position].orderId ? orders[position].orderId : null}</label>
                          </div>
                        </Col>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>categories</label>
                          <div>
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.85rem', color: 'rgb(13 151 207)' }}>{orders[position]?.categoryId?.category ? orders[position]?.categoryId?.category : null}</label>
                          </div>
                        </Col>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>place</label>
                          <div style={{ color: 'rgb(13 151 207)' }}>
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.85rem', color: 'rgb(13 151 207)' }}>{orders[position]?.placeId?.category?.area}</label>-
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.85rem', color: 'rgb(13 151 207)' }}>{orders[position]?.placeId?.area ? orders[position]?.placeId?.area : null}</label>
                          </div>
                        </Col>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>service</label>
                          <div>
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.85rem', color: 'rgb(13 151 207)' }}>{orders[position]?.serviceId?.title ? orders[position]?.serviceId?.title : null}</label>
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: '1px solid #eeeeee', width: '100%' }}>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>description</label>
                          <div>
                            <label style={{ color: 'rgb(13 151 207)', fontWeight: 'bold', fontSize: '0.9rem', textTransform: 'uppercase' }}>{orders[position].description !== 'undefined' ? orders[position].description : 'No description'}</label>
                          </div>
                        </Col>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>photos</label>
                          <div style={{ display: 'flex', flexDirection: 'row' }}>
                            {orders[position].photos && orders[position].photos.length > 0 && (
                              orders[position].photos.map((item, index) => (
                                <div style={{ margin: 10, overflow: 'hidden', borderRadius: 5 }}>
                                  <ModalImage
                                    className="image-bgsize"
                                    small={item}
                                    large={item}
                                    hideDownload={true}
                                    hideZoom={true}
                                  />
                                </div>
                              )))}
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: '1px solid #eeeeee', padding: '10px 0px 10px 0px', width: '100%' }}>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>Location</label>
                          <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div>
                              <IcomoonReact iconSet={iconSet} style={{ paddingLeft: 2 }} color="rgb(15 145 187)" size={14} icon="loations" />
                            </div>
                            <div style={{ marginLeft: 8 }}>
                              <div style={{ color: 'rgb(112 117 100)', textTransform: 'uppercase', fontSize: '0.9rem' }}>
                                <label style={{ color: 'rgb(13 151 207)', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.8rem' }}>{orders[position]?.sub_locationId?.location ? orders[position]?.sub_locationId?.location : null}</label>
                                <label style={{ color: 'rgb(13 151 207)', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.8rem', marginLeft: 2 }}>, {orders[position]?.locationId?.location ? orders[position]?.locationId?.location : null}</label>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>priority</label>
                          <div style={{ width: '6rem', padding: 6, textTransform: 'uppercase', color: 'rgb(245 57 60)', fontSize: '0.7rem', textAlign: 'center', fontWeight: 'bold', backgroundColor: '#f9cfcf', border: 'none', boxShadow: 'none', borderRadius: '10px' }}>
                            {orders[position]?.priorityId?.priority}
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: '1px solid #eeeeee', padding: 0, width: '100%', paddingBottom: '20px' }}>
                        <label style={{ fontSize: '0.7rem', paddingLeft: 20, marginTop: 10 }}>ADD PARTS</label>
                        {/* <div style={{position:'absolute',marginTop:40,zIndex:1999,marginLeft:20}}><IcomoonReact iconSet={iconSet} color="black" size={12} icon="search" /></div> */}
                        <Col md="11" >
                          <Field >
                            {({ input, meta }) => (
                              <div >
                                <ReactSearchAutocomplete
                                  styling={{
                                    borderRadius: '8px',
                                    searchIconMargin: '4px 4px 0 0',
                                    marginLeft: '20px',
                                    margin: '40px',
                                    zIndex: 999
                                  }}
                                  placeholder='Search parts'
                                  items={products}
                                  onSelect={selectparts}
                                  showIcon={true}
                                  autoFocus
                                />
                              </div>
                            )}
                          </Field>
                        </Col>
                        {selectPartsInfo && selectPartsInfo.length > 0 ?
                          <Table size="sm" style={{ width: '87%', marginLeft: '20px', marginTop: '20px' }} >
                            <thead>
                              <tr style={{ backgroundColor: 'rgb(242 242 242)' }}>
                                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>PARTS NAME</th>
                                <th style={{ paddingLeft: 30 }}>QTY</th>
                                <th>PRICE</th>
                                {/* <th>REMARKS</th> */}
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectPartsInfo && selectPartsInfo.length > 0 && (
                                selectPartsInfo.map((item, index) => (
                                  <ProductView item={item} actionToRoot={actionFromRoot} openparts={openparts} setOpenparts={setOpenparts} />
                                )))}
                            </tbody>
                          </Table> : null
                        }
                      </Row>
                      <Row>
                        <label style={{ fontSize: '0.7rem', paddingLeft: 20, marginTop: 10 }}>COMMENTS</label>
                        <Col md="11">
                          <FormGroup>
                            <Field name="comments" initialValue={orders?.[position]?.comments}>
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    style={{ padding: 30, backgroundColor: '#efefef', color: 'black' }}
                                    {...input}
                                    type="text"
                                  />
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                      </Row>
                      {orders?.[position]?.comments && (
                        <>
                          <Row>
                            <label style={{ fontSize: '0.7rem', paddingLeft: 20, marginTop: 10 }}>ADDITIONAL COMMENTS</label>
                            <Col md="11">
                              <FormGroup>
                                <Field name="additional_comments" initialValue={orders?.[position]?.additional_comments} >
                                  {({ input, meta }) => (
                                    <div>
                                      <Input
                                        style={{ padding: 30, backgroundColor: '#efefef', color: 'black' }}
                                        {...input}
                                        type="text"
                                      />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <label style={{ fontSize: '0.7rem', paddingLeft: 20, marginTop: 10, textTransform: 'uppercase' }}>Parts Comments</label>
                            <Col md="11">
                              <FormGroup>
                                <Field name="parts_comments" initialValue={orders?.[position]?.parts_comments}>
                                  {({ input, meta }) => (
                                    <div>
                                      <Input
                                        style={{ padding: 30, backgroundColor: '#efefef', color: 'black' }}
                                        {...input}
                                        type="text"
                                      />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      )}
                    </div>
                  </Scrollbars>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Col md="6" >
                      <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: 'rgb(20 150 180)', width: '80%', color: 'white', borderRadius: '50px', boxShadow: 'none', padding: 10, marginBottom: '20px', textAlign: 'center' }} >
                        {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                        SUBMIT</Button>{' '}
                    </Col>
                  </div>
                </form>
              )}
            />
          </div>
        </Modal>
      </div>
      {/* ----*/}
      {/* edit status */}
      <div style={{ width: '600px' }}>
        <Modal
          className="modal-dialog-centered"
          isOpen={statusopen}
        >
          <div onClick={statusClose} style={{ backgroundColor: 'rgb(193 193 124)', width: '30px', height: '30px', position: 'absolute', right: '-10px', top: '-10px', borderRadius: '50%' }}>
            <IcomoonReact iconSet={iconSet} onClick={statusClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div className="modal-header" style={{ backgroundColor: 'rgb(5 160 187)', flexDirection: 'column' }} >
            <h2 style={{ marginTop: '20px', marginLeft: 20, color: 'white' }} className="modal-title" id="exampleModalLabel">
              EDIT STATUS
            </h2>
          </div>
          <div>
            <Form
              onSubmit={onSubmit_status}
              render={({ handleSubmit }) => (
                <form
                  onSubmit={handleSubmit} style={{ padding: '20px' }}>
                  <div className="pl-lg-4">

                    <Row> {orders[position].status !== 'completed' ?
                      <Col lg="12">
                        <FormGroup >
                          <Label style={{ fontSize: ' 0.8125rem' }} for="status"> SELECT STATUS</Label>
                          <Field name="status" >
                            {({ input, meta, value }) => (
                              <div>
                                <Input required type="select" name="status" id="status" onClick={(e) => Setstatuschange(e.target.value)} style={{ color: 'black' }}>
                                  <option selected={orders[position]?.status === 'pending' || status_slct === 'pending'} value="pending">Pending</option>
                                  <option selected={orders[position]?.status === 'over due' || status_slct === 'over due'} value="over due">Overdue</option>
                                  {tech && tech.length > 0 && orders[position]?.status === 'assigned' || orders[position]?.status === 'completed' || orders[position]?.status === 'in progress' ? null : <option selected={orders[position]?.status === 'cancelled' || status_slct === 'cancelled'} value="cancelled">Cancelled</option>}
                                  <option selected={orders[position]?.status === 'in progress' || status_slct === 'in progress'} value="in progress">Inprogress</option>
                                  <option selected={orders[position]?.status === 'assigned' || status_slct === 'assigned'} value="assigned">Assigned</option>
                                  {/* {tech && tech.length > 0 && orders[position]?.status === 'assigned' ? <option selected={orders[position]?.status === 'completed' || status_slct === 'completed'} value="completed">Completed</option> : null} */}
                                  <option selected={orders[position]?.status === 'completed' || status_slct === 'completed'} value="completed">Completed</option>
                                </Input>
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col> :
                      <Col lg="12">
                        <FormGroup >
                          <Label style={{ fontSize: ' 0.8125rem' }} for="status"> SELECT STATUS</Label>
                          <Field name="status" >
                            {({ input, meta, value }) => (
                              <div>
                                <Input required type="select" name="status" id="status" onClick={(e) => Setstatuschange(e.target.value)} style={{ color: 'black' }}>
                                  <option value="reopened">Reopened</option>
                                </Input>
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>}
                    </Row>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Col md="6" >
                      <Button type="submit" disabled={loading} onClick={() => statuseditClose()} color={'white'} style={{ backgroundColor: 'rgb(0 139 183)', width: '80%', color: 'white', borderRadius: '50px', boxShadow: 'none' }} >
                        {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                        DONE</Button>{' '}
                    </Col>
                  </div>
                </form>
              )}
            />
          </div>
        </Modal>
      </div>
      {/* ----*/}
      {/* reason for decresing order  */}
      <Modal
        className="modal-dialog-centered"
        isOpen={openparts}
      >
        <div onClick={partsclosemodal} style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-9px', top: '-10px', borderRadius: '50%' }}>
          <IcomoonReact iconSet={iconSet} onClick={partsclosemodal} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
        </div>
        <div className="modal-header">
          <h5 style={{ marginLeft: 15 }}>REASON FOR DECREASING THE STOCK</h5>
        </div>
        <div>
          <Row>
            <Col md="12" style={{ padding: '20px', paddingLeft: '20px', paddingRight: '37px', paddingTop: 0 }}>
              <div className="pl-lg-4" >
                <Input
                  type="text"
                  name="reason"
                  placeholder="Reason for decreasing the stock"
                  // value={result ? result:''}
                  style={{ color: 'black', padding: 40, height: 50 }}
                  // onChange={(e) => setReason(e.target.value)}
                  onChange={(e) => SearchInfoQuantity(e.target.value, productid)}
                />
              </div>
              <span style={{ color: 'red', fontSize: '0.8rem', paddingLeft: 22 }}>{error}</span>
              <Col md="4" >
                <div style={{ marginLeft: 10, marginTop: 10 }}>
                  <Button onClick={() => resultsubmit()} color={'white'} style={{ backgroundColor: 'rgb(0 139 183)', color: 'white', width: '100%', borderRadius: '10px' }} >
                    {/* <Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} /> */}
                    SUBMIT</Button>{' '}
                </div>
              </Col>
            </Col>
          </Row>
        </div>
      </Modal>
      {/* ----*/}
      <Modal isOpen={modalerroropen} size="sm">
        <ModalBody style={{ color: 'red' }}>Please fill all the mandatory fields...!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20, marginRight: 20 }}>
          <Button onClick={ClosemodalError} style={{ backgroundColor: '#ff473a', color: 'white' }} type="button">
            OK
          </Button>
        </div>
      </Modal>
      <div style={{ width: '600px' }}>
        <Modal
          className="modal-dialog-centered"
          isOpen={viewopen}
          style={{
            maxWidth: '700px',
          }}
        >
          <div onClick={viewClose} style={{ backgroundColor: 'rgb(193 193 124)', width: '30px', height: '30px', position: 'absolute', right: '-6px', top: '-10px', borderRadius: '50%', cursor: 'pointer' }}>
            <IcomoonReact iconSet={iconSet} onClick={viewClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div className="modal-header" style={{ backgroundColor: 'rgb(5 160 187)', flexDirection: 'column', display: 'flex', padding: '8px' }} >
            <h2 style={{ marginTop: '20px', marginLeft: 30, color: 'white', textTransform: 'uppercase' }} className="modal-title" id="exampleModalLabel">
              {orders[position]?.serviceId?.title}
            </h2>
            <h3 style={{ marginTop: '20px', marginLeft: 30, color: 'white', fontSize: '0.8rem', marginTop: 5 }}>
              <label style={{ color: 'rgb(128 207 209)' }}>Created on {moment(orders[position]?.createdOn).format('LLL')}</label>
            </h3>
          </div>
          <div>
            <Form
              onSubmit={onSubmit_update}
              render={({ handleSubmit }) => (
                <form
                  onSubmit={handleSubmit} style={{ padding: '10px' }}>
                  <Scrollbars
                    renderThumbVertical={props => < div {...props} className="thumb-vertical" />}
                    renderTrackVertical={props => < div {...props} className="track-vertical" />}
                    renderThumbHorizontal={props => < div {...props} />}
                    // onScrollStart={props => < div {...props} className="scroll-start" />}
                    // renderView={props => <div {...props} className="view" />}
                    //scrollToBottom
                    autoHide={false}
                    autoHeight={true}
                    autoHeightMin={360}
                    autoHeightMax={365}
                  >
                    <div className="pl-lg-4">
                      <Row style={{ borderBottom: '1px solid #eeeeee', width: '100%', padding: '0px 0px 10px 0px' }}>
                        <Col lg="5" style={{ width: '40%' }}>
                          <div style={{ width: 'maxContent', marginBottom: 20 }}>
                            <div style={{
                              border: '1px solid rgb(0 139 183)',
                              height: '60px',
                              borderRadius: '5px',
                              margin: 0,
                              overflow: 'hidden',
                              fontWeight: 600
                            }} >
                              <div onClick={() => opendropdowntechnician()} style={{ display: 'flex', marginLeft: 10, marginTop: 5 }}>
                                <div style={{ border: '1px solid rgb(0 139 183)', width: 30, borderRadius: '50%', height: 30, marginTop: 8 }}>
                                  <IcomoonReact style={{ marginLeft: 5 }} iconSet={iconSet} color="rgb(14 145 186)" size={20} icon="assigned-technician" />
                                </div>
                                {technicianslct && technicianslct.length > 0 || orders[position]?.technicianIds && orders[position]?.technicianIds.length > 0 ?
                                  <div><label style={{ fontSize: '0.6rem', marginLeft: 10 }}>ASSIGNED</label></div> :
                                  <div><label style={{ fontSize: '0.6rem', marginLeft: 10 }}>NOT ASSIGNED</label></div>}
                              </div>
                              <div onClick={() => opendropdowntechnician()} style={{ display: 'flex', marginLeft: 40, marginTop: '-10px' }}>
                                {technicianslct && technicianslct.length > 0 ? (
                                  technicianslct.map((item, index) => (
                                    <div type="text" id=""
                                      style={{
                                        width: '200px',
                                        backgroundColor: 'transparent',
                                        color: 'rgb(0 139 183)',
                                        padding: '0px',
                                        marginLeft: 10,
                                        display: 'inline-block',
                                        outline: 'none',
                                        border: 'none',
                                        fontSize: '0.8rem',
                                        whiteSpace: 'nowrap',
                                      }}>{item?.name}</div>
                                  ))
                                ) : (
                                  <div style={{
                                    width: '100%',
                                    backgroundColor: 'transparent',
                                    color: 'rgb(0 139 183)',
                                    padding: '0px',
                                    outline: 'none',
                                    border: 'none',
                                    fontSize: '0.8rem',
                                    paddingLeft: 6
                                  }}>{techname && techname.length > 0 ? techname : 'ASSIGN A TECHNICIAN'}</div>
                                )}
                              </div>
                              <div onClick={() => opendropdowntechnician()} style={{ position: 'absolute', right: 30, top: 15, }}>
                                <IcomoonReact iconSet={iconSet} color="rgb(14 145 186)" size={12} icon="drop-down" />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md="3" style={{ display: 'flex', flexDirection: 'column' }}>
                          <label style={{ fontSize: '0.6rem', textTransform: 'uppercase', marginLeft: 20 }}>status</label>
                          <div style={{ display: 'flex', marginLeft: 20 }}>
                            <div>
                              <span class="badge-dot badge ">
                                <i class={(orders[position]?.status === 'completed') ? 'bg-success' : 'bg-danger'}></i>
                              </span>
                            </div>
                            <div>
                              <label style={{
                                color: orders[position]?.status === 'completed' ? 'green' : 'red',
                                border: '1px solid transparent',
                                backgroundColor: '#fff',
                                paddingBottom: 25,
                                textTransform: 'uppercase',
                                fontWeight: 'bold',
                                fontSize: '0.8rem'
                              }}>
                                {orders[position]?.status ? orders[position]?.status : 'pending'}
                              </label>
                            </div>
                          </div>
                        </Col>
                        {orders[position]?.availabilityId !== null && orders[position]?.priorityId.priority === 'Normal' ?
                          <Col md="4" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>Date & Time </label>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <label style={{ fontSize: '0.9rem', color: 'rgb(13 151 207)', textTransform: 'capitalize', fontWeight: 'bold' }}>{orders[position]?.availabilityId?.title ? orders[position]?.availabilityId?.title : null}</label>
                              <label style={{ fontSize: '0.9rem', color: 'rgb(13 151 207)', textTransform: 'capitalize', fontWeight: 'bold' }}>{orders[position]?.time ? orders[position]?.time : null}</label>
                            </div>
                          </Col> : null}
                        {/* {orders[position]?.availabilityId !== null ? <Col md="4" style={{ display: 'flex', flexDirection: 'column' }}>
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>Date & Time </label>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ fontSize: '0.9rem', color: 'rgb(13 151 207)', textTransform: 'capitalize', fontWeight: 'bold' }}>{orders[position]?.availabilityId?.title ? orders[position]?.availabilityId?.title : null}</label>
                            <label style={{ fontSize: '0.9rem', color: 'rgb(13 151 207)', textTransform: 'capitalize', fontWeight: 'bold' }}>{orders[position]?.time ? orders[position]?.time : null}</label>
                          </div>
                        </Col> : null} */}
                      </Row>
                      <Row style={{ borderBottom: '1px solid #eeeeee', width: '100%', padding: '0px 0px 10px 0px' }}>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>order id</label>
                          <div>
                            <label style={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.85rem', color: 'rgb(13 151 207)' }}>{orders[position].orderId ? orders[position].orderId : null}</label>
                          </div>
                        </Col>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>categories</label>
                          <div>
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.85rem', color: 'rgb(13 151 207)' }}>{orders[position]?.categoryId?.category ? orders[position]?.categoryId?.category : null}</label>
                          </div>
                        </Col>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>place</label>
                          <div style={{ color: 'rgb(13 151 207)' }}>
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.85rem', color: 'rgb(13 151 207)' }}>{orders[position]?.placeId?.category?.area}</label>-
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.85rem', color: 'rgb(13 151 207)' }}>{orders[position]?.placeId?.area ? orders[position]?.placeId?.area : null}</label>
                          </div>
                        </Col>
                        <Col md="3">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>service</label>
                          <div>
                            <label style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '0.85rem', color: 'rgb(13 151 207)' }}>{orders[position]?.serviceId?.title ? orders[position]?.serviceId?.title : null}</label>
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: '1px solid #eeeeee', width: '100%', padding: '0px 0px 20px 0px ' }}>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>description</label>
                          <div>
                            <label style={{ color: 'rgb(13 151 207)', textTransform: 'uppercase', fontSize: '0.9rem', fontWeight: 'bold' }}>{orders[position].description !== 'undefined' ? orders[position].description : 'No description'}</label>
                          </div>
                        </Col>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>photos</label>
                          <div style={{ display: 'flex', flexDirection: 'row' }}>
                            {orders[position].photos && orders[position].photos.length > 0 && (
                              orders[position].photos.map((item, index) => (
                                <div style={{ margin: 5, overflow: 'hidden', borderRadius: 5 }}>
                                  <ModalImage
                                    className="image-bgsize"
                                    small={item}
                                    large={item}
                                    hideDownload={true}
                                    hideZoom={true}
                                  />
                                </div>
                              )))}
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: '1px solid #eeeeee', padding: '10px 0px 20px 0px', width: '100%' }}>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>Location</label>
                          <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div>
                              <IcomoonReact iconSet={iconSet} style={{ paddingLeft: 2 }} color="rgb(15 145 187)" size={14} icon="loations" />
                            </div>
                            <div style={{ marginLeft: 8 }}>
                              <label style={{ color: 'rgb(13 151 207)', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '0.8rem' }}>
                                <span>{`${orders[position]?.sub_locationId?.location !== 'undefined' ? orders[position]?.sub_locationId?.location : null}, ${orders[position]?.locationId?.location !== 'undefined' ? orders[position]?.locationId?.location : null}`}</span>
                              </label>
                              {/* <label style={{ color: 'black', textTransform: 'uppercase', fontSize: '0.9rem' }}>{orders[position]?.sub_locationId?.location !=='undefined'?orders[position]?.sub_locationId?.location:null + ',' + orders[position]?.locationId?.location !== 'undefined'? orders[position].locationId: null}</label> */}
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <label style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>priority</label>
                          <div style={{ width: '6rem', padding: 6, textTransform: 'uppercase', color: 'rgb(245 57 60)', fontSize: '0.7rem', textAlign: 'center', fontWeight: 'bold', backgroundColor: '#f9cfcf', border: 'none', boxShadow: 'none', borderRadius: '10px' }}>
                            {orders[position]?.priorityId?.priority}
                          </div>
                        </Col>
                      </Row>
                      {orders[position].productIds && orders[position].productIds.length > 0 ?
                        <Table size="sm" style={{ width: '91%', marginTop: '20px' }} >
                          <thead>
                            <tr style={{ backgroundColor: 'rgb(242 242 242)' }}>
                              <th>PARTS NAME</th>
                              <th>QTY</th>
                              <th>PRICE</th>
                              {/* <th>REMARKS</th> */}
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {orders[position].productIds && orders[position].productIds.length > 0 && (
                              orders[position].productIds.map((item, index) => (
                                <>
                                  <tr style={{ border: '1px solid #ccc' }}>
                                    <td style={{ color: '#044058', fontWeight: 'bold' }}>{item.name}</td>
                                    <td>
                                      <div>
                                        <span style={{ fontWeight: 'bold', fontSize: '0.7rem', textAlign: 'center' }}>{item.count}</span>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <span style={{ fontWeight: 'bold', fontSize: '0.7rem', textAlign: 'center' }}>{item.count * item.price}</span>
                                      </div>
                                    </td>
                                    {/* {item.count * item.price === 0 ? <td>
                                      <div>
                                        <span style={{ fontWeight: 'bold', fontSize: '0.7rem', textAlign: 'center' }}>{item?.desc}</span>
                                      </div>
                                    </td> : null} */}
                                  </tr>
                                </>
                              )))}
                          </tbody>
                        </Table>
                        : null}
                      <Row>
                        <label style={{ fontSize: '0.7rem', paddingLeft: 20, marginTop: 20 }}>COMMENTS</label>
                        <Col md="11">
                          <FormGroup>
                            <Field name="comments" initialValue={orders?.[position]?.comments}>
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    style={{ padding: 15, backgroundColor: '#efefef', color: 'black' }}
                                    disabled
                                    type="textarea"
                                  />
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                      </Row>
                      {orders?.[position]?.comments && (
                        <>
                          <Row>
                            <label style={{ fontSize: '0.7rem', paddingLeft: 20, marginTop: 10 }}>ADDITIONAL COMMENTS</label>
                            <Col md="11">
                              <FormGroup>
                                <Field name="additional_comments" initialValue={orders?.[position]?.additional_comments} >
                                  {({ input, meta }) => (
                                    <div>
                                      <Input
                                        style={{ padding: 15, backgroundColor: '#efefef', color: 'black' }}
                                        {...input}
                                        type="textarea"
                                      />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <label style={{ fontSize: '0.7rem', paddingLeft: 20, marginTop: 10, textTransform: 'uppercase' }}>Parts Comments</label>
                            <Col md="11">
                              <FormGroup>
                                <Field name="parts_comments" initialValue={orders?.[position]?.parts_comments}>
                                  {({ input, meta }) => (
                                    <div>
                                      <Input
                                        style={{ padding: 15, backgroundColor: '#efefef', color: 'black' }}
                                        {...input}
                                        type="textarea"
                                      />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      )}
                    </div>
                  </Scrollbars>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 20 }}>
                    <Col md="6" >
                      <Button disabled={loading} color={'white'} style={{ backgroundColor: 'rgb(20 150 180)', width: '80%', color: 'white', borderRadius: '50px', boxShadow: 'none', padding: '10px 30px 10px 40px', marginBottom: '20px', textAlign: 'center', display: 'flex', justifyContent: 'center' }} >
                        {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                        DONE</Button>{' '}
                    </Col>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Pdf targetRef={ref} filename={'ReopenedWorkorder' + orders[position]?.orderId}>
                      {({ toPdf }) => {
                        return (
                          <Button type='submit'
                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid black', width: '35%', marginRight: 50, borderRadius: '50px', boxShadow: 'none', padding: '8px 30px 8px 40px', marginBottom: '20px', textAlign: 'center', display: 'flex', justifyContent: 'center' }}
                            onClick={() => {
                              toPdf();
                            }}> <AiOutlineDownload color='black' fontSize="1.5em" />DOWNLOAD PDF</Button>
                        );
                      }}
                    </Pdf>
                  </div>
                </form>
              )}
            />
          </div>
          <div style={{ position: 'absolute', top: '-9999px', left: '-9999px' }}>
            <div ref={ref} style={{ width: 800, height: 700, marginBottom: 30 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginLeft: 45, paddingLeft: 45, marginTop: 30 }}>
                <img src={require('../../../assets/img/brand/babal-logo.png').default} style={{ width: 80 }} alt="..." />
                <div style={{ display: 'flex', flexDirection: 'column', marginRight: 30 }}>
                  <div>
                    <label style={{ color: 'black' }}>Date:</label>
                    <label style={{ color: 'black', marginLeft: 2, fontWeight: 600, fontSize: '0.9rem' }}>{Todaydate}</label >
                  </div>
                  <div>
                    <label style={{ color: 'black' }}>Time: </label>
                    <label style={{ color: 'black', marginLeft: 2, fontWeight: 600, fontSize: '0.9rem' }}>{Todaytime}</label >
                  </div>
                </div>
              </div>
              <h1 style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.4rem', marginTop: 10 }}>WORK ORDER DETAILS</h1>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 30 }}>
                <div style={{ display: 'flex', flexDirection: 'column', color: 'black', margin: 20 }}>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <label style={{ fontSize: '1rem' }}>order Id:</label>
                    <label style={{ marginLeft: 20, fontWeight: 600, fontSize: '0.9rem' }}>{orders[position]?.orderId}</label>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                    <label style={{ fontSize: '1rem' }} >Location: </label>
                    <label style={{ marginLeft: 20, fontWeight: 600, fontSize: '0.9rem' }}>{orders[position]?.locationId?.location ? orders[position]?.locationId?.location : null}</label >
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                    <label style={{ fontSize: '1rem' }} >Order Details: </label>
                    <label style={{ marginLeft: 20, fontWeight: 600, fontSize: '0.9rem' }}>{orders[position]?.serviceId?.title}</label >
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                    <label style={{ fontSize: '1rem' }} >Category: </label>
                    <label style={{ marginLeft: 20, fontWeight: 600, fontSize: '0.9rem' }}>{orders[position]?.categoryId?.category ? orders[position]?.categoryId?.category : null}</label >
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                    <label style={{ fontSize: '1rem' }} >Affected place:</label>
                    <label style={{ marginLeft: 20, fontWeight: 600, fontSize: '0.9rem' }}>{orders[position]?.placeId?.category?.area},{orders[position]?.placeId?.area ? orders[position]?.placeId?.area : null}</label >
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', color: 'black', margin: 20 }}>
                  {orders[position]?.availabilityId !== null ? <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <label style={{ fontSize: '1rem' }} >Created Date & Time:</label>
                    <label style={{ marginLeft: 20, fontWeight: 600, fontSize: '0.9rem' }}>{createddate}</label >
                    {/* <label style={{ marginLeft: 20, fontWeight: 600, fontSize: '0.9rem' }}>{orders[position]?.createdOn ? orders[position]?.createdOn : null}</label> */}
                  </div> : null}
                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                    <label style={{ fontSize: '1rem' }} >Villa no:</label>
                    <label style={{ marginLeft: 20, fontWeight: 600, fontSize: '0.9rem' }}> {orders[position]?.sub_locationId?.location ? orders[position]?.sub_locationId?.location : null}</label>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                    <label style={{ fontSize: '1rem' }} >Status:</label>
                    <label style={{ marginLeft: 20, fontWeight: 600, color: orders[position]?.status === 'completed' ? 'green' : 'red', textTransform: 'capitalize', fontSize: '0.9rem' }}>  {orders[position]?.status ? orders[position]?.status : 'pending'}</label >
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                    <label style={{ fontSize: '1rem' }} >Priority:</label>
                    <label style={{ marginLeft: 20, fontWeight: 600, fontSize: '0.9rem' }}> {orders[position]?.priorityId?.priority}</label >
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                    <label style={{ fontSize: '1rem' }} >Day & time selected:</label>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {orders[position]?.availabilityId !== null ? <label style={{ marginLeft: 20, fontWeight: 600, fontSize: '0.9rem', fontSize: '0.8rem' }}>{orders[position]?.availabilityId?.title ? orders[position]?.availabilityId?.title : null},{orders[position]?.time ? orders[position]?.time : null}</label > : null}
                    </div>
                  </div>
                </div>
              </div>
              {orders[position]?.productIds && orders[position]?.productIds?.length > 0 ?
                <label style={{ marginLeft: 40, paddingLeft: 10, color: 'black', fontWeight: 'bold', marginTop: 10 }}>Parts Used</label> : null}
              {orders[position]?.productIds && orders[position]?.productIds?.length > 0 ? <Table style={{ width: '80%', marginTop: 30, marginLeft: 50, paddingLeft: 35 }}>
                <thead>
                  <tr>
                    <th style={{ fontWeight: 'bold', color: 'black', fontSize: '0.7rem', textAlign: 'center', border: 'thin solid black', padding: 5 }}>Sl NO</th>
                    <th style={{ fontWeight: 'bold', color: 'black', fontSize: '0.7rem', textAlign: 'center', border: 'thin solid  black', padding: 5 }}>Parts Name</th>
                    <th style={{ fontWeight: 'bold', color: 'black', fontSize: '0.7rem', textAlign: 'center', border: 'thin solid black', padding: 5 }}>Qunatity</th>
                    <th style={{ fontWeight: 'bold', color: 'black', fontSize: '0.7rem', textAlign: 'center', border: 'thin solid black', padding: 5 }}>Price</th>
                    {/* <th style={{ fontWeight: 'bold', color: 'black', fontSize: '0.7rem', textAlign: 'center', border: 'thin solid black', padding: 5 }}>Remarks</th> */}
                  </tr>
                </thead>
                <tbody>
                  {orders[position]?.productIds && orders[position]?.productIds?.length > 0 ? (
                    orders[position]?.productIds.map((item, index) => (
                      <>
                        <tr>
                          <th style={{ textAlign: 'center', fontWeight: 'bold', color: 'black', border: 'thin solid black', padding: 5, boxShadow: 'none' }} scope="row">{index + 1}</th>
                          <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 5, color: 'black', boxShadow: 'none' }}>{item?.name}</td>
                          <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 5, color: 'black', boxShadow: 'none' }}>{item?.count}</td>
                          <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 5, color: 'black', boxShadow: 'none' }}>{item?.count * item?.price}</td>
                          {/* {item.count * item.price === 0 ? <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 5, color: 'black', boxShadow: 'none' }}>{item?.desc}</td> : <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 5, color: 'black', boxShadow: 'none' }}>{null}</td>} */}
                        </tr>
                      </>
                    ))) :
                    <>
                      <tr>
                        <th style={{ textAlign: 'center', fontWeight: 'bold', color: 'black', border: 'thin solid black', padding: 5, boxShadow: 'none' }} scope="row"></th>
                        <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 10, color: 'black', boxShadow: 'none' }}></td>
                        <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 10, color: 'black', boxShadow: 'none' }}></td>
                        <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 10, color: 'black', boxShadow: 'none' }}></td>
                      </tr>
                      <tr>
                        <th style={{ textAlign: 'center', fontWeight: 'bold', color: 'black', border: 'thin solid black', padding: 5, boxShadow: 'none' }} scope="row"></th>
                        <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 10, color: 'black', boxShadow: 'none' }}></td>
                        <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 10, color: 'black', boxShadow: 'none' }}></td>
                        <td style={{ textAlign: 'center', border: 'thin solid black', fontSize: '0.8rem', padding: 10, color: 'black', boxShadow: 'none' }}></td>
                      </tr>
                    </>
                  }
                </tbody>
              </Table> : null}
            </div>
          </div>
        </Modal>
      </div>
      <Modal isOpen={peropen} size="sm">
        <ModalBody style={{ color: 'red' }}>You have no acess to change it..!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => permodalClose()} style={{ backgroundColor: 'red', color: 'white', border: 0 }}>Ok</Button>
        </div>
      </Modal>
    </>
  );
};

export default Reopened;
